import { render, staticRenderFns } from "./MatrixView.vue?vue&type=template&id=e3f581b6&scoped=true&"
import script from "./MatrixView.vue?vue&type=script&lang=js&"
export * from "./MatrixView.vue?vue&type=script&lang=js&"
import style0 from "./MatrixView.vue?vue&type=style&index=0&id=e3f581b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f581b6",
  null
  
)

export default component.exports
import {QMarkupTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMarkupTable})
